<template>
	<TabWrapper @save="submit" @change="change" @deploy:preview="submit('preview')"
							@deploy:live="submit('live')" :hideButtonRowMargin="true">
		<v-container fluid>
			<v-row>
				<v-col>
					<AceEditor
						v-model="content"
						@init="editorInit"
						lang="javascript"
						theme="chrome"
						width="100%"
						height="600"
						:options="aceConfig"
						:commands="[{
                            name: 'save',
                            bindKey: { win: 'Ctrl-s', mac: 'Command-s'},
                            exec: submit,
                            readOnly: readOnly
                        }]"
					/>
				</v-col>
			</v-row>
			<div v-if="siteDetails" class="mt-2">Zuletzt geändert
				am: {{ lastEdited }}
			</div>
		</v-container>
	</TabWrapper>
</template>

<script>
'use strict;'
import TabWrapper from "./TabWrapper";
import AceEditor from 'vuejs-ace-editor';
import Utils from "../../../scripts/Utils";

export default {
	name: "LocalJs",
	components: {TabWrapper, AceEditor},
	props: ['readOnly'],
	data: () => {
		return {
			content: null,
			editor: null,
		}
	},
	mounted() {
		this.init();
		this.$emit('activeComponent', this);
	},
	computed: {
		vuexState() {
			return this.$store.state.display;
		},
		siteDetails() {
			return this.vuexState.siteDetails;
		},
		activeTab() {
			return this.vuexState.activeTab;
		},
		aceConfig() {
			let ret = this.$store.state.aceConfig;
			ret.readOnly = this.readOnly;
			return ret;
		},
		lastEdited() {
			if (this.siteDetails) {
				if (this.siteDetails.Js.Updated && this.siteDetails.Js.Created) {
					return Utils.formatDate((new Date(this.siteDetails.Js.Updated) > new Date(this.siteDetails.Js.Created) ? this.siteDetails.Js.Updated : this.siteDetails.Js.Created), true)
				} else if (this.siteDetails.Js.Updated) {
					return Utils.formatDate(this.siteDetails.Js.Updated);
				} else if (this.siteDetails.Js.Created) {
					return Utils.formatDate(this.siteDetails.Js.Created);
				}
			}
			return '';
		}
	},
	methods: {
		init() {
			if (this.siteDetails) {
				this.content = Utils.htmlDecode(this.siteDetails.Js.Value);
			}
		},
		editorInit(editor) {
			//JShint options https://jshint.com/docs/options/
			this.editor = editor;
			editor.session.on("changeMode", (e, session) => {
				//session.$worker.send("setOptions", [{maxerr: 1000, loopfunc: true}])
				session.$worker.send("setOptions", [{maxerr: 1000, loopfunc: false}])
			})
			require('brace/ext/searchbox'); //language extension prerequsite...
			require('brace/ext/language_tools'); //language extension prerequsite...
			require('brace/mode/javascript');    //language
			require('brace/snippets/javascript')
			require('brace/theme/chrome');
		},
		validateCode() {
			if (this.editor.getSession().getAnnotations().filter(x => x.type === 'error').length !== 0) {
				this.$root.$emit('snackbar', 'Fehler in der Local.js gefunden. Zum Fortfahren bitte alle Fehler beheben.', 'error');
				return false;
			} else {
				return true;
			}
		},
		submit(type = '') {
			if (this.validateCode()) {
				if (type === 'preview') {
					this.$emit('deploy:preview', this);
				} else if (type === 'live') {
					this.$emit('deploy:live', this);
				} else {
					this.$emit('submit', this);
				}
			}
		},
		change() {
			if (this.vuexState.previousTab === this.$options._componentTag) {
				this.$emit('change', this);
			} else if (this.activeTab === this.$options._componentTag) {
				this.$emit('activeComponent', this);
			}
		},
		dataChanged() {
			let changed = false;
			if (this.content !== Utils.htmlDecode(this.siteDetails.Js.Value)) {
				changed = true;
			}
			return changed;
		},
		getBody() {
			return {
				publisher_id: this.siteDetails.Site.PublisherId,
				site_id: this.siteDetails.Site.SiteId,
				type_id: this.siteDetails.Current.SitetypeId,
				Js: this.content
			}
		}
	},
	watch: {
		siteDetails() {
			this.init()
		}
	},
}
</script>

<style scoped>

</style>